module.exports = __webpack_public_path__ + "img/8.14f7dd57.png";